export const ROUTES = {
  HOME: "/",
  ABOUT: "/about",
  SETUP: "/setup",
  ADJUDICATOR: "/adjudicator",
  CURRENT: "/current",
  MC: "/mc",
  CHAIRPERSON: "/chairperson",
  DJ: "/dj",
  FLOOR_MANAGER: "/floor-manager",
  MONITOR: "/monitor",
  LED_SCREEN: "/led",
  BROADCAST_SCREEN: "/broadcast",
  VISUAL_CONTROLLER: "/control",
} as const;

export default ROUTES;
type t = typeof ROUTES;
export type RoutesType =  t[keyof t];